import * as Api from '@ViewModels';
import { useMemo } from 'react';
import { useEmailLikeStepSave, type UseEmailLikeStepSaveOverrides } from './useEmailLikeStepSave';
import type { useAutoSave } from './useAutoSave';

interface UseAIEmailStepSaveProps {
	aiEmailStep: Api.IAIEmailAutomationStep | null;
	stepId: string | undefined;
	templateId: string | undefined;
	name: string;
	prompt: string;
	tagToAddOnClick: string;
	skipStepContactFilter: Api.IContactsFilterRequest | null | undefined;
	autoSave: ReturnType<typeof useAutoSave>;
}

/** Re-export the overrides type for callers. */
export type UseAIEmailStepSaveOverrides = UseEmailLikeStepSaveOverrides;

interface UseAIEmailStepSaveResult {
	save: (overrides?: UseAIEmailStepSaveOverrides) => Promise<void>;
}

/**
 * Save hook for AIEmailStepRenderer.
 * Delegates to the shared useEmailLikeStepSave hook, adding the prompt.
 */
export function useAIEmailStepSave({
	aiEmailStep,
	stepId,
	templateId,
	name,
	prompt,
	tagToAddOnClick,
	skipStepContactFilter,
	autoSave,
}: UseAIEmailStepSaveProps): UseAIEmailStepSaveResult {
	const extraFields = useMemo(() => ({ prompt }), [prompt]);

	return useEmailLikeStepSave<Api.IAIEmailAutomationStep>({
		step: aiEmailStep,
		stepId,
		stepType: Api.AutomationStepType.AIEmail,
		templateId,
		name,
		tagToAddOnClick,
		skipStepContactFilter,
		autoSave,
		extraFields,
	});
}
